// extracted by mini-css-extract-plugin
export default {"wrapper":"tags_wrapper__P46vs","gameboardButton":"tags_gameboardButton__mOB7z"};